export const PLATFORMS = Object.freeze([
  {
    id: 'engagenet',
    name: 'Engagenet',
    monogram: 'E',
    color: 'var(--secondary-color, #4481eb)',
    logo: 'https://empirewebvideos.s3.us-east-1.amazonaws.com/worksteams/engagenet/images/platform_icons/engagenet.webp',
    app_code: null,
    launch_path: '/home',
  },
  {
    id: 'aic_one',
    name: 'AIC One',
    monogram: 'A',
    color: '#C8102E',
    logo: 'https://empirewebvideos.s3.us-east-1.amazonaws.com/worksteams/engagenet/images/aicone_logo_v3.webp',
    app_code: 'Home',
  },
  {
    id: 'orcaa',
    name: 'Orcaa.ai',
    monogram: 'Or',
    color: '#0E7CC4',
    logo: 'https://empirewebvideos.s3.us-east-1.amazonaws.com/worksteams/engagenet/images/platform_icons/orcaa.webp',
    app_code: 'Orcaa',
  },
  {
    id: 'x-verdict',
    name: 'Xverdict',
    monogram: 'X',
    color: '#7C3AED',
    logo: 'https://empirewebvideos.s3.us-east-1.amazonaws.com/worksteams/engagenet/images/platform_icons/xverdict.webp',
    app_code: 'x-verdict',
  },
  {
    id: 'complyon',
    name: 'Comply On',
    monogram: 'C',
    color: '#B45309',
    logo: 'https://empirewebvideos.s3.us-east-1.amazonaws.com/worksteams/engagenet/images/platform_icons/complyon.webp',
    app_code: 'Complyon',
  },
  {
    id: 'complyon_onboard',
    name: 'Onboard',
    monogram: 'On',
    color: '#0F766E',
    logo: 'https://empirewebvideos.s3.us-east-1.amazonaws.com/worksteams/engagenet/images/platform_icons/onboarding.webp',
    app_code: 'complyon_onboard',
  },
  {
    id: 'workflow',
    name: 'Proba Workflows',
    monogram: 'PW',
    color: '#4338CA',
    logo: 'https://empirewebvideos.s3.us-east-1.amazonaws.com/worksteams/engagenet/images/platform_icons/proba.webp',
    app_code: 'Proba_workflows',
  },
  {
    id: 'proba',
    name: 'Proba Analytics',
    monogram: 'PA',
    color: '#BE123C',
    logo: 'https://empirewebvideos.s3.us-east-1.amazonaws.com/worksteams/engagenet/images/platform_icons/proba.webp',
    app_code: 'Proba_analytics',
  },
]);

export const PLATFORM_IDS = Object.freeze(PLATFORMS.map(platform => platform.id));

export const FALLBACK_PLATFORM_COLOR = '#6B5F60';

const PLATFORMS_BY_ID = Object.freeze(
  PLATFORMS.reduce((map, platform) => {
    Reflect.set(map, platform.id, platform);
    return map;
  }, Object.create(null)),
);

export const PLATFORM_NAME_TO_ID = Object.freeze(Object.assign(Object.create(null), {
  'aic one': 'aic_one',
  aic_one: 'aic_one',
  'orcaa ai': 'orcaa',
  orcaa: 'orcaa',
  orca: 'orcaa',
  engagenet: 'engagenet',
  'ic workbook': 'engagenet',
  'x verdict': 'x-verdict',
  xverdict: 'x-verdict',
  complyon: 'complyon',
  'comply on': 'complyon',
  'complyon onboard': 'complyon_onboard',
  complyon_onboard: 'complyon_onboard',
  onboard: 'complyon_onboard',
  onboardid: 'complyon_onboard',
  'proba workflows': 'workflow',
  workflows: 'workflow',
  workflow: 'workflow',
  'proba analytics': 'proba',
  proba: 'proba',
  analytics: 'proba',
}));

export function get_platform_config(platform_id) {
  return Reflect.get(PLATFORMS_BY_ID, platform_id) || null;
}

export function normalize_platform_name(name) {
  return String(name || '')
    .trim()
    .toLowerCase()
    .replace(/[._-]/g, ' ')
    .replace(/\s+/g, ' ')
    .trim();
}

export function platform_id_for_name(name) {
  const normalized = normalize_platform_name(name);
  return Reflect.get(PLATFORM_NAME_TO_ID, normalized) || null;
}


